export const mapToArray = <T = {}>(obj: Object): T[] => {
  return Object.values(obj);
};

export const getServiceSlotIdentifier = (slot: { lineItemId: string }) => {
  return slot.lineItemId;
};
